import type { ProductSource } from '#shared/types/core/common'
import type {
  CheckoutRequest,
  CheckoutResponse,
} from '#shared/types/core/ecommerce/checkout'

export function useCheckoutApi() {
  const api = useCoreApi('ecommerce/checkout')
  return {
    async initiateCheckoutSession(
      productSource: ProductSource,
      request: CheckoutRequest,
      redirectUrl?: string,
    ) {
      return await api.$fetch<CheckoutResponse>('/', {
        method: 'POST',
        body: request,
        query: {
          productSource,
          redirectUrl,
        },
      })
    },

    async getCheckoutSession(sessionId: UUID) {
      return await api.$fetch<CheckoutResponse>(api.endpoint(sessionId))
    },
  }
}
